/* hikerjoy · pagina de hamac în stilul nuit (șablonul product.hamace-v3).
   Eticheta din galerie, cardul de sub galerie, data de livrare, cardurile „Un hamac / Două hamace”, bifele din „Completează pachetul”.
   Un singur produs în coș (1 hamac sau același hamac de 2 ori): îl adaugă tema, ca de obicei.
   Mai multe produse (alt al doilea hamac sau bife): le adăugăm într-o singură cerere și deschidem sertarul de coș al temei.
   Datele vin din [data-hjn-config] (snippets/hj-n-after.liquid).
   Șosete: cardurile „1 / 2 / 3 perechi” ([data-hjn-qty]); la 3 perechi, a doua și a treia se aleg din [data-hjn-pair] (orice model). */
(function () {
  var cfg = document.querySelector('[data-hjn-config]');
  if (!cfg) return;
  var base = parseInt(cfg.getAttribute('data-base'), 10) || 0;
  var addUrl = cfg.getAttribute('data-add') || '/cart/add.js';
  var cartUrl = cfg.getAttribute('data-cart') || '/cart';

  var fmt = function (c) {
    var s = (c / 100).toFixed(2).replace('.', ',');
    if (s.slice(-3) === ',00') s = s.slice(0, -3);
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' lei';
  };

  if (cfg.getAttribute('data-hammock') === 'true') {
    var viewer = document.querySelector('.media-gallery__viewer');
    if (viewer && !viewer.querySelector('.hjn-badge')) {
      var badge = document.createElement('span');
      badge.className = 'hjn-badge';
      badge.textContent = cfg.getAttribute('data-badge');
      viewer.appendChild(badge);
    }
    var promise = document.querySelector('[data-hjn-promise]'), media = document.querySelector('.product-media');
    if (promise && media && window.matchMedia('(min-width: 769px)').matches) media.appendChild(promise);
  }

  var eta = document.querySelector('[data-hj-eta]');
  if (eta && window.hjEta) {
    var r = window.hjEta(), d = r.date;
    var zile = ['duminică', 'luni', 'marți', 'miercuri', 'joi', 'vineri', 'sâmbătă'];
    var luni = ['ian.', 'feb.', 'mar.', 'apr.', 'mai', 'iun.', 'iul.', 'aug.', 'sept.', 'oct.', 'nov.', 'dec.'];
    eta.innerHTML = 'Comanzi azi, ajunge până <strong>' + zile[d.getDay()] + ', ' + d.getDate() + ' ' + luni[d.getMonth()] + '</strong>';
    var nt = document.querySelector('[data-hj-eta-note]');
    if (nt && r.holidays.length) { nt.textContent = window.hjEtaNote(r.holidays); nt.hidden = false; }
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href^="#"]') : null;
    if (!a || a.getAttribute('href').length < 2) return;
    var t = document.getElementById(a.getAttribute('href').slice(1));
    if (t && t.tagName === 'DETAILS') t.open = true;
  });

  var form = document.querySelector('.js-product-form-main');
  if (!form) return;
  var btn = form.querySelector('button[name="add"]');
  var qty = form.querySelector('input[name="quantity"]');
  var idIn = form.querySelector('input[name="id"]');
  var tiers = document.querySelector('[data-hjn-tiers]');
  var sel = tiers ? tiers.querySelector('[data-hjn-second]') : null;
  var qtyMode = !!(tiers && tiers.hasAttribute('data-hjn-qty'));
  var pairs = tiers ? [].slice.call(tiers.querySelectorAll('[data-hjn-pair]')) : [];
  var err = document.querySelector('[data-hjn-error]');
  var opt = function (s) { return s.options[s.selectedIndex]; };
  var tier = function () {
    var c = tiers && tiers.querySelector('input[type="radio"]:checked');
    return c ? parseInt(c.value, 10) : 1;
  };
  var ups = function () {
    var out = [];
    document.querySelectorAll('[data-hjn-up]').forEach(function (c) {
      if (!c.checked) return;
      var row = c.closest('.hjn-up'), s = row && row.querySelector('[data-hjn-up-select]'), o = s ? opt(s) : null;
      out.push({ id: parseInt(o ? o.value : c.value, 10), price: parseInt(o ? o.getAttribute('data-price') : c.getAttribute('data-price'), 10) || 0 });
    });
    return out;
  };
  var plan = function () {
    var main = parseInt(idIn ? idIn.value : 0, 10), items = [], total = base;
    if (qtyMode) {
      var n = tier();
      if (n === 3 && pairs.length) {
        var byId = {}, order = [];
        var add = function (id, price) {
          if (!byId[id]) { byId[id] = { id: id, quantity: 0 }; order.push(id); }
          byId[id].quantity += 1;
          total += price;
        };
        total = 0;
        add(main, base);
        pairs.forEach(function (s) { var o = opt(s); add(parseInt(o.value, 10), parseInt(o.getAttribute('data-price'), 10) || base); });
        order.forEach(function (id) { items.push(byId[id]); });
      } else {
        items.push({ id: main, quantity: n });
        total = base * n;
      }
    } else if (tier() === 2 && sel && sel.options.length) {
      var o = opt(sel), second = parseInt(o.value, 10), p2 = parseInt(o.getAttribute('data-price'), 10) || base;
      total = Math.round((base + p2) * 0.9);
      if (second === main) items.push({ id: main, quantity: 2 });
      else items.push({ id: main, quantity: 1 }, { id: second, quantity: 1 });
    } else {
      items.push({ id: main, quantity: 1 });
    }
    ups().forEach(function (u) { items.push({ id: u.id, quantity: 1 }); total += u.price; });
    return { items: items, total: total };
  };
  var render = function () {
    if (tiers) {
      tiers.querySelectorAll('.hjn-tier').forEach(function (el) {
        var c = el.querySelector('input[type="radio"]');
        el.classList.toggle('is-selected', !!(c && c.checked));
      });
      if (sel && sel.options.length) {
        var p2 = parseInt(opt(sel).getAttribute('data-price'), 10) || base;
        var a = tiers.querySelector('[data-hjn-t2]'), b = tiers.querySelector('[data-hjn-t2-full]');
        if (a) a.textContent = fmt(Math.round((base + p2) * 0.9));
        if (b) b.textContent = fmt(base + p2);
      }
      if (pairs.length) {
        var main0 = idIn ? idIn.value : '';
        pairs.forEach(function (s) { if (!s.hasAttribute('data-touched') && main0 && s.querySelector('option[value="' + main0 + '"]')) s.value = main0; });
        var t3 = base;
        pairs.forEach(function (s) { t3 += parseInt(opt(s).getAttribute('data-price'), 10) || base; });
        var c3 = tiers.querySelector('[data-hjn-t3]');
        if (c3) c3.textContent = fmt(t3);
      }
    }
    document.querySelectorAll('.hjn-up').forEach(function (row) {
      var c = row.querySelector('[data-hjn-up]'), s = row.querySelector('[data-hjn-up-select]'), pr = row.querySelector('[data-hjn-up-price]');
      row.classList.toggle('is-checked', !!(c && c.checked));
      if (s && pr) pr.textContent = fmt(parseInt(opt(s).getAttribute('data-price'), 10) || 0);
    });
    var p = plan();
    if (qty) qty.value = p.items.length === 1 ? p.items[0].quantity : 1;
    if (btn && !btn.disabled && btn.getAttribute('aria-disabled') !== 'true') {
      var label = (qtyMode ? (tier() > 1 ? 'Adaugă ' + tier() + ' perechi în coș' : 'Adaugă în coș') : (tier() === 2 ? 'Adaugă 2 hamace în coș' : 'Adaugă în coș')) + ' — ' + fmt(p.total);
      btn.textContent = label;
      btn.setAttribute('data-add-to-cart-text', label);
    }
  };

  if (tiers) {
    tiers.addEventListener('change', render);
    tiers.querySelectorAll('.hjn-tier').forEach(function (el) {
      el.addEventListener('click', function (e) {
        if (e.target.closest('select, option, label, input')) return;
        var c = el.querySelector('input[type="radio"]');
        if (c && !c.checked) { c.checked = true; render(); }
      });
    });
  }
  pairs.forEach(function (s) { s.addEventListener('change', function () { s.setAttribute('data-touched', '1'); }); });
  document.querySelectorAll('[data-hjn-up], [data-hjn-up-select]').forEach(function (el) { el.addEventListener('change', render); });
  document.addEventListener('change', function (e) { if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(render, 300); });
  render();

  document.addEventListener('submit', function (e) {
    if (e.target !== form) return;
    var p = plan();
    if (p.items.length < 2) { if (qty) qty.value = p.items[0].quantity; return; }
    e.preventDefault();
    e.stopImmediatePropagation();
    if (!window.fetch || !btn || btn.getAttribute('aria-disabled') === 'true') return;
    btn.setAttribute('aria-disabled', 'true');
    btn.classList.add('is-loading');
    if (err) { err.hidden = true; err.textContent = ''; }
    var drawer = document.querySelector('cart-drawer');
    var secs = ['cart-icon-bubble'];
    var ds = drawer && drawer.closest('.shopify-section');
    if (ds) secs.push(ds.id.replace('shopify-section-', ''));
    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: p.items, sections: secs.join(','), sections_url: window.location.pathname })
    }).then(function (res) {
      return res.json().then(function (data) { return { ok: res.ok, data: data }; });
    }).then(function (res) {
      if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || '');
      var after = window.theme && window.theme.settings && window.theme.settings.afterAtc;
      if (after === 'page' || !drawer || typeof drawer.renderContents !== 'function') { window.location.href = cartUrl; return; }
      drawer.renderContents(res.data, true);
    }).catch(function (x) {
      if (err) { err.textContent = (x && x.message) ? x.message : 'Nu am putut adăuga produsele în coș. Încearcă din nou.'; err.hidden = false; }
    }).then(function () {
      btn.removeAttribute('aria-disabled');
      btn.classList.remove('is-loading');
    });
  }, true);
})();